import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Routing from "./routes/Routing";
import { BASEPATH } from "./utils/StaticRouterLinks";

function App() {
  return (
    <div className="">
      <BrowserRouter basename={BASEPATH}>
        <Routing />
      </BrowserRouter>
    </div>
  );
}

export default App;
